import React, { useState, useEffect } from 'react';
import './App.css';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import ResetPassword from './components/ResetPassword';
import { verifyToken } from './api/auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [resetToken, setResetToken] = useState(() => {
    try { return new URLSearchParams(window.location.search).get('reset'); } catch { return null; }
  });

  useEffect(() => {
    // Check if user is already logged in
    const token = localStorage.getItem('token');
    if (token) {
      verifyToken(token)
        .then((response) => {
          setUser(response.user);
          setIsAuthenticated(true);
        })
        .catch(() => {
          localStorage.removeItem('token');
          setIsAuthenticated(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('token', token);
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="app-container loading">
        <div className="spinner"></div>
        <p>Loading ConnectMi...</p>
      </div>
    );
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>🌐 ConnectMi.ai</h1>
        <p className="tagline">Reciprocal Trust Network</p>
      </header>

      <main className="app-main">
        {resetToken && !isAuthenticated ? (
          <ResetPassword
            token={resetToken}
            onDone={() => {
              setResetToken(null);
              // strip the token from the URL so it isn't reused or bookmarked
              try { window.history.replaceState({}, '', window.location.pathname); } catch (e) { /* ignore */ }
            }}
          />
        ) : isAuthenticated ? (
          <Dashboard user={user} onLogout={handleLogout} onUserUpdate={setUser} />
        ) : (
          <Auth onLogin={handleLogin} />
        )}
      </main>

      <footer className="app-footer">
        <p>© 2024 ConnectMi. Building trust networks, one connection at a time.</p>
      </footer>
    </div>
  );
}

export default App;
